import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PhoneInput from "@Shared/components/inputs/phone-input";
import GenericModal from "@Shared/components/modals/generic-modal.vue";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import Select2 from "@Shared/components/inputs/select2.vue";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { REFERRER_TYPE_OPTIONS } from "@Shared/@Utils/constants";
import { cloneDeep } from "lodash";
import { REFERRAL_SOURCE_ENABLED } from "@Broker/@Modules/main/store/account/account-getters";
import { mapGetters } from "vuex";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ManageReferrerModal",
  components: {
    PhoneInput,
    GenericModal,
    MaterialInput,
    Select2,
    SimpleButton
  },
  mixins: [validationMixin],
  validations: {
    referrer: {
      familyName: {
        required
      },
      givenName: {
        required
      },
      type: {
        required
      },
      email: {
        email
      }
    }
  },
  props: {
    referrerValue: {
      type: Object,
      default: null
    },
    submitting: {
      type: Object,
      default: () => ({
        loading: false,
        status: true
      })
    }
  },
  data() {
    const defaultReferrer = {
      email: "",
      familyName: "",
      givenName: "",
      id: "",
      phoneNumber: "",
      specialNote: "",
      type: "",
      customFields: [],
      active: 0,
      inactive: 0
    };
    return {
      defaultReferrer,
      referrer: defaultReferrer
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("AccountStore", [REFERRAL_SOURCE_ENABLED])), {}, {
    createMode() {
      var _this$referrerValue;
      return !((_this$referrerValue = this.referrerValue) != null && _this$referrerValue.id);
    },
    modalActionText() {
      return this.createMode ? this.$t("referrers.actions.addReferrerModal") : this.$t("referrers.actions.editReferrer");
    },
    invalid() {
      return this.$v.$invalid;
    },
    select2Options() {
      return {
        placeholder: this.$t("referrers.actions.selectAReferrerType"),
        dropdownParent: "#referrers-select-container",
        closeOnSelect: true
      };
    },
    referrerTypeOptions() {
      return REFERRER_TYPE_OPTIONS();
    },
    referralSourceEnabled() {
      return this.REFERRAL_SOURCE_ENABLED;
    }
  }),
  mounted() {
    if (this.REFERRAL_SOURCE_ENABLED) {
      this.$set(this.defaultReferrer, "referralCode", "");
      this.$set(this.referrer, "referralCode", "");
    }
  },
  methods: {
    handleShow() {
      if (this.referrerValue) this.$set(this, "referrer", _objectSpread(_objectSpread({}, this.defaultReferrer), this.referrerValue));else this.resetValues();
    },
    handleHidden() {
      this.resetValues();
    },
    showModal() {
      this.$showModal();
    },
    hideModal() {
      this.$hideModal();
    },
    handleSubmit() {
      if (this.invalid) return;
      this.$emit("submit", {
        referrer: this.referrer,
        create: this.createMode
      });
    },
    handleReferrerTypeChange({
      id
    }) {
      this.referrer.type = id;
    },
    resetValues() {
      this.referrer = cloneDeep(this.defaultReferrer);
      this.$v.$reset();
    }
  }
});